import { Component, OnInit, Output, ViewChild, EventEmitter, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SectoresProductivosService } from 'src/app/services/sectores-productivos.service';

import {MatSort} from '@angular/material/sort';

@Component({
  selector: 'app-tabla-sectores-productivos',
  templateUrl: './tabla-sectores-productivos.component.html',
  styleUrls: ['./tabla-sectores-productivos.component.css']
})
export class TablaSectoresProductivosComponent implements OnInit {

  sectGenerales: any;
  subsectores: any;
  displayedColumns: string[] = ['id', 'descripcion'];
  dataSource: any;

  @Output()
  sectorById = new EventEmitter<number>();

  @Output()
  backTo = new EventEmitter<number>();

  @Input() idSector:number;
  @Input() title: string;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @Input() estandar:string;

  constructor(private service: SectoresProductivosService) {
      this.idSector = 0;
   }

  ngOnInit(): void {
    this.getSectores();
  }

  async getSectores() {

    if(this.estandar.trim()===""){
      this.estandar='NA';
    }

    try {
      let get: any;
      if(this.idSector === 0){
        get = await this.service.getSectoresProductivos();
      }else{
        // componente no se esta usando se deja el estandar como ''
        get = await this.service.getSectoresProductivosById(this.idSector,this.estandar);
      }
      this.dataSource = new MatTableDataSource<any>(get)
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } catch (error) {
      console.log(error);
    }
  }

  async getSectoresById() {
    try {
      const get = await this.service.getSectoresProductivosById(1,'NA');
      this.subsectores = get;
    } catch (error) {
      console.log(error);
    }
  }

  sectorByID(element) {
    this.sectorById.emit(element);
  }

  back(){
    this.backTo.emit(this.idSector);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
